// extracted by mini-css-extract-plugin
module.exports = {"asosFocus":"_30rEw7y","skipLink":"_1ojZITY _30rEw7y"};